import { useReducer, useEffect, useContext, useState } from "react";
import { reducer } from "../lib.utils";
import config from "../lib.config";
import { NewsletterContext } from "@lib/contexts";
import UCL from "@lib/user-client-libs";

const useUser = () => {
  const [ucl, setUcl] = useState(null);
  const initialState = {
    isLogged: false,
    isPremium: false,
    username: "",
    email: "",
    token: "",
    loading: true
  };
  const [state, dispatch] = useReducer(reducer, initialState);
  const { username, email, isPremium, isMobile } =
    useContext(NewsletterContext);

  useEffect(() => {
    // Cargar el módulo solo del lado del cliente
    if (typeof window !== "undefined") {
      const uclModule = new UCL();
      setUcl(uclModule);
    }
  }, []);

  useEffect(() => {
    const checkToken = async () => {
      const uclLocal = new UCL();
      const token = await uclLocal.GetIdTokenValidatedAsync();

      if (!token) {
        dispatch({ type: "isLogged", value: false });
      } else {
        dispatch({ type: "isLogged", value: true });
        dispatch({
          type: "username",
          value: username,
        });
        dispatch({ type: "email", value: email });
        dispatch({
          type: "isPremium",
          value: isPremium,
        });
        dispatch({ type: "token", value: token})
      } 
      
      dispatch({ type: "loading", value: false });
    };

    checkToken();
  }, [username, email, isPremium]);

  const suscribe = () => {
    window.location.href = `${config.paywallUrl}${window.btoa(
      window.location.href
    )}`;
  };

  const login = () => {
    window.location.href = config.loginUrl + window.btoa(window.location.href);
  };

  const logout = async (callback) => {
    if (callback) {
      callback();
    }
    if (ucl) {
      const properties = {
        isVoluntary: true,
        ...(isMobile && { embedShortCircuit: true }),
      };
      const { LogoutAsync } = ucl;
      await LogoutAsync(properties);
    }
    dispatch({ type: "isLogged", value: false });
  };

  return {
    ...state,
    suscribe,
    login,
    logout,
  };
};

export default useUser;
